<template>
  <div class="frame-divider" data-testid="frame-divider-wrap">

    <div class="frame-divider__primary"
         data-testid="frame-divider-primary"
         :style="{ width: primaryWidth }">
      <slot name="primary" />
    </div>

    <div v-if="renderPane"
         class="frame-divider__secondary"
         :class="{ 'pane-shadow': isPaneShadowed }"
         :style="{ width: secondaryWidth, overflowY: paneOverflow }"
         data-testid="frame-divider-secondary">
      <slot name="secondary" />
    </div>

  </div>

</template>

<script>
export default {
  name: 'FrameDivider',
  props: {
    renderPane: {
      type: Boolean,
      required: false,
      default: true
    },
    paneWidth: {
      type: Number,
      required: false,
      default: 370,
    },
    paneScrollable: {
      type: Boolean,
      required: false,
      default: false
    },
    isPaneShadowed: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    primaryWidth() {
      return this.renderPane ? `calc(100% - ${this.secondaryWidth})` : '100%'
    },
    secondaryWidth() {
      return `${this.paneWidth}px`
    },
    paneOverflow() {
      return this.paneScrollable ? 'auto' : 'hidden'
    },
  },

}
</script>

<style lang="scss" scoped>

.frame-divider {
  display: flex;
  width: 100%;
  max-height: 100vh;
  overflow: hidden;

  &__primary, &__secondary {
    position: relative;
  }

  &__primary {
    overflow-y: auto;
  }

  .pane-shadow {
    box-shadow: 0px 4px 5px -2px rgb(0 0 0 / 20%), 0px 7px 10px 1px rgb(0 0 0 / 14%), 0px 2px 16px 1px rgb(0 0 0 / 12%);
  }

}

</style>
